<!-- alert.component.html -->

<div class="app-alert-container">

  @for (alert of alerts; track alert) {

    <div
      [ngClass]="cssClass(alert)"
      role="alert"
    >

      <!-- ICON -->
      <div class="alert-icon">

        @switch (alert.type) {

          @case ('Success') {
            <i class="bi bi-check-circle-fill"></i>
          }

          @case ('Error') {
            <i class="bi bi-x-circle-fill"></i>
          }

          @case ('Info') {
            <i class="bi bi-info-circle-fill"></i>
          }

          @case ('Warning') {
            <i class="bi bi-exclamation-triangle-fill"></i>
          }

          @default {
            <i class="bi bi-bell-fill"></i>
          }
        }

      </div>

      <!-- CONTENT -->
      <div class="alert-content">

        <div
          class="alert-message"
          [innerHTML]="alert.message"
        ></div>

      </div>

      <!-- CLOSE -->
      <button
        type="button"
        class="btn-close app-alert-close"
        aria-label="Close"
        (click)="removeAlert(alert)"
      ></button>

    </div>

  }

</div>